"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOOD_LOOP_ANIMATION_OPTIONS = exports.ERROR_ANIMATION_OPTIONS = exports.SUCCESS_ANIMATION_OPTIONS = exports.LOADING_ANIMATION_OPTIONS = exports.States = exports.Colors = exports.Sizes = void 0;

var _designLanguage = require("@doordash/design-language");

var _error = _interopRequireDefault(require("./animations/error.lottie"));

var _foodLoop = _interopRequireDefault(require("./animations/food-loop.lottie"));

var _loading = _interopRequireDefault(require("./animations/loading.lottie"));

var _success = _interopRequireDefault(require("./animations/success.lottie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sizes = {
  Small: 24,
  Medium: 32,
  Large: 40,
  XLarge: 64,
  XxLarge: 96,
  XxxLarge: 128
};
exports.Sizes = Sizes;

var Colors = _objectSpread({
  Dark: _designLanguage.Colors.SystemBlack,
  Light: _designLanguage.Colors.SystemWhite,
  Red: _designLanguage.Colors.SystemRed60,
  Ocean: _designLanguage.Colors.SystemTeal60,
  CurrentColor: 'currentColor'
}, _designLanguage.Colors);

exports.Colors = Colors;
var States = {
  Loading: 'LOADING/LOADING',
  Success: 'LOADING/SUCCESS',
  Error: 'LOADING/ERROR',
  FoodLoop: 'LOADING/FOOD_LOOP'
};
exports.States = States;
var LOADING_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: _loading["default"]
};
exports.LOADING_ANIMATION_OPTIONS = LOADING_ANIMATION_OPTIONS;
var SUCCESS_ANIMATION_OPTIONS = {
  loop: false,
  autoplay: true,
  animationData: _success["default"]
};
exports.SUCCESS_ANIMATION_OPTIONS = SUCCESS_ANIMATION_OPTIONS;
var ERROR_ANIMATION_OPTIONS = {
  loop: false,
  autoplay: true,
  animationData: _error["default"]
};
exports.ERROR_ANIMATION_OPTIONS = ERROR_ANIMATION_OPTIONS;
var FOOD_LOOP_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: _foodLoop["default"]
};
exports.FOOD_LOOP_ANIMATION_OPTIONS = FOOD_LOOP_ANIMATION_OPTIONS;